import { postUpdateVisible } from '../api/postUpdateVisible';

const setPostUpdateVisible = (params) => {
    return async (dispatch, getState) => {
        try {
            await postUpdateVisible(params);     
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdateVisible
}